import React from 'react'
import Resume from '../../assets/Resume.pdf'

const ResumeButton = () => {
  return (
    <div className='resume'>
      <a href={Resume} download  className='btn'>Download Resume</a>
      <a href='#contact' className='btn btn-primary'>Let's Talk</a>
    </div>
  )
}

export default ResumeButton